import Int64LookupPagingResultModelBase from '../_generated/modelBases/int64-lookup-paging-result-model-base';

export default class Int64LookupPagingResultModel extends Int64LookupPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
